import WarehouseList from './WarehouseList';
export default WarehouseList;
